(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('SecurityExceptionsController', ["$scope", "$q", "widgetSettings", "securityEventsDao", "tablePaginationHelper", "defaultListConverter", "modulesManager", "modals", "columnsHelper", function ($scope, $q, widgetSettings, securityEventsDao, tablePaginationHelper, defaultListConverter, modulesManager, modals, columnsHelper) {
        $scope.initializing = true;
        var exceptionTypes;
        $q.all([
            modulesManager.refreshStates(),
            securityEventsDao.exceptionTypes().then(function (response) {
                exceptionTypes = response.data;
            })
        ]).then(function () {
            $scope.options = {
                columns: [
                    {
                        id: 'id',
                        primary: true,
                        hidden: true
                    },
                    {
                        id: 'created',
                        text: 'Created',
                        format: 'time',
                        sortable: true
                    },
                    {
                        id: 'saas',
                        text: 'SaaS',
                        converter: 'eventSaas',
                        dataClass: 'saas-icon',
                        sortable: true,
                        filter: {
                            name: 'filterEnum_saas',
                            type: 'enum'
                        },
                        property: {
                            variants: _(modulesManager.activeSaasApps()).map(function (saas) {
                                return {
                                    id: saas.name,
                                    label: saas.title
                                };
                            })
                        }
                    },
                    {
                        id: 'is_running',
                        text: 'Running',
                        converter: 'booleanCheckConverter',
                        converterArgs: { checkClass: '' },
                        filter: {
                            name: 'filterEnum_is_running',
                            type: 'boolean'
                        }
                    },
                    {
                        id: '_resolved.exception_label',
                        text: 'Type',
                        filter: {
                            name: 'filterEnum_entity_type',
                            type: 'enum'
                        },
                        property: {
                            variants: _(exceptionTypes).map(function (type, typeId) {
                                return {
                                    id: typeId,
                                    label: type.label
                                };
                            })
                        }
                    },
                    {
                        id: '_resolved',
                        hidden: true
                    },
                    {
                        id: 'subject',
                        text: 'Exception',
                        converter: 'exceptionSubjectConverter'
                    }
                ],
                options: {
                    checkboxes: true,
                    defaultOrdering: {
                        columnName: 'created',
                        order: 'desc'
                    }
                }
            };
            $scope.tableOptions = {
                disableTop: true,
                orderDisplayMode: 'highlight-column',
                asDivs: true,
                infinite: true,
                showWorkingIndicator: true,
                workingIndicatorDisableGui: false,
                saveState: true,
                headerOptions: { enum: { multiple: true } },
                pagination: {
                    pageSize: 10,
                    ordering: {}
                },
                dropdownHeader: true,
                actions: [{
                        label: 'Delete...',
                        display: 'button',
                        active: function () {
                            return $scope.tableHelper.getSelectedIds().length > 0;
                        },
                        execute: function () {
                            var message, title = 'Delete Exception', selectedIds = $scope.tableHelper.getSelectedIds();
                            if (!selectedIds.length) {
                                return;
                            }
                            if (selectedIds.length === 1) {
                                message = 'Are you sure you want to delete selected exception?';
                            } else {
                                message = 'Are you sure you want to delete ' + selectedIds.length + ' selected exceptions?';
                                title += 's';
                            }
                            modals.confirm({
                                message: message,
                                title: title,
                                okText: 'Delete'
                            }).then(function () {
                                return $q.all(_(selectedIds).map(function (exceptionId) {
                                    return securityEventsDao.deleteException(exceptionId);
                                }));
                            }).then(function () {
                                $scope.tableHelper.clearSelection();
                                $scope.tableHelper.reload();
                            });
                        }
                    }]
            };
            $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
                var params = columnsHelper.filtersToParams(args.columnsFilters);
                params.resolve = true;
                var result = securityEventsDao.listExceptions().params(params);
                return result.pagination(args.offset, args.limit).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                    return {
                        columns: $scope.options.columns,
                        converters: {
                            eventSaas: function (text) {
                                if (_(text).isNull()) {
                                    return '';
                                }
                                return '#' + JSON.stringify({
                                    display: 'saas-icon',
                                    saas: modulesManager.cloudApp(text),
                                    text: modulesManager.cloudApp(text).title,
                                    path: modulesManager.cloudApp(text).img
                                });
                            },
                            exceptionSubjectConverter: function (text, columnId, columnsMap) {
                                if (!columnsMap._resolved) {
                                    return text;
                                }
                                if (!columnsMap._resolved.entity_type || !columnsMap._resolved.entity_id) {
                                    return columnsMap._resolved.entity_label;
                                }
                                return '#' + JSON.stringify({
                                    display: 'link',
                                    type: 'profile',
                                    entityType: columnsMap._resolved.entity_type,
                                    id: columnsMap._resolved.entity_id,
                                    text: columnsMap._resolved.entity_label
                                });
                            }
                        }
                    };
                });
            }, function (tableModel) {
                $scope.initializing = false;
                $scope.tableModel = tableModel;
                $scope.tableOptions.infoText = 'Total exceptions found: ' + $scope.tableHelper.getTotal();
            });
        });
    }]);
}());